<template>
  <div class="ic-card">
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          <p class="order-title-boxs"><span class="blueBlock"></span><i>IC卡信息</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">转卡状态</div>
              <div class="itemNum jishi">{{ form.swivelClampStatusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">账户状态</div>
              <div class="itemNum moneys">{{ form.statusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">IC卡号</div>
              <div class="itemNum">{{ form.cardLogicNo }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">登记姓名</div>
              <div class="itemNum">{{ form.username }}</div>
            </div>
           <div class="flex-row mb30">
              <div class="itemName">手机号码</div>
              <div class="itemNum">{{ form.userTel }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">卡内余额</div>
              <div class="itemNum moneys">￥{{ form.vipLogRestMoney }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">来源门店</div>
              <div class="itemNum">{{ form.machShopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">操作人</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡时间</div>
              <div class="itemNum">{{ formatDate(form.turnDate) }}</div>
            </div>
          </div>
          <p class="order-title-boxs"><span class="blueBlock"></span><i>转卡记录</i></p>
          <div class="totals-box pl24">
            <div class="flex-row mb30">
              <div class="itemName">会员姓名</div>
              <div class="itemNum">{{ form.nickName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">会员性别</div>
              <div class="itemNum">{{ form.gender == 'male' ? "男" : '女' }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">电话号码</div>
              <div class="itemNum">{{ form.mobile }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡门店</div>
              <div class="itemNum">{{ form.shopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">操作人员</div>
              <div class="itemNum">{{ form.staffName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">转卡时间</div>
              <div class="itemNum">{{ formatDate(form.turnDate) }}</div>
            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button @click="back">取消</el-button>
        </div>
      </div>
    </drawer>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import drawer from "../../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "IC详情",
      addEditShow: false,
      form: {},
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.icCard.get, {
            id: org.id
          }).then(res => {
            if (res) {
              this.form = res;
            }
          });
      });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.pay-mains {
  padding: 0;
  
}
</style>